<template>
<div>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link>
        /
        <router-link :to="{name: 'admin-import' }" class="root">
            Admin Import
        </router-link>
        <span class="child">/ Import Subject </span>
    </v-row>
    <span>
        <v-btn color="blue" dark class="mb-2" :loading="isLoading" v-on="on" @click="synchsubject()" style="margin:2px;float:right;">Synchronization Courses from ERP</v-btn>
    </span>
    <br>
    <br>
    <div class="mx-auto container container--fluid">

        <br />
        <v-card class="card">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card-title class="heading">Import Subject</v-card-title>
            <v-card class="box">
                        <div class="flex">
                            <div></div>
                            <div>
                                <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/Import_Subject.csv">
                            <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn" @click="loader = 'loading3'">
                                <v-icon left dark>mdi-cloud-download</v-icon>
                                Download import CSV format
                            </v-btn>
                        </a>
                            </div>
                        </div>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" lg="4" sm="12">
                                    <v-file-input dense accept=".csv" v-model="file" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000">
                        </v-file-input>
                                </v-col>
                                <v-col cols="4"> </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <center>
                                        <v-btn @click="submitFile" :loading="output_load" class="button">
                                Upload
                                <v-icon right>mdi-cloud-upload</v-icon>
                            </v-btn>
                                    </center>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
            <!-- <v-container>

                <v-row>
                    <v-col cols="4">
                        <v-file-input dense accept=".csv" v-model="file" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000">
                        </v-file-input>
                    </v-col>
                    <v-col cols="4"> </v-col>
                    <v-col cols="4">
                        <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/Import_Subject.csv">
                            <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn" @click="loader = 'loading3'">
                                <v-icon left dark>mdi-cloud-download</v-icon>
                                Download import CSV format
                            </v-btn>
                        </a>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <center>
                            <v-btn @click="submitFile" :loading="output_load" class="button">
                                Upload
                                <v-icon right>mdi-cloud-upload</v-icon>
                            </v-btn>
                        </center>
                    </v-col>
                </v-row>
            </v-container> -->
            <template v-if="load==true">
                <v-data-table 
                v-model="selected"
                      @current-items="getFiltered"
                :headers="headers" :items="course_list1" sort-by="ptype" class="elevation-1 nowrap" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <download-excel class="mar" :data="filterArr" :fields="export_table_headers" worksheet="course_list" name="SubjectData.xls">
                                <v-btn color="success" dark class="mb-2">
                                    Export<v-icon dark>mdi-file-excel</v-icon>
                                </v-btn>
                            </download-excel>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                            <span style="width: 20px;"></span>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="button" v-on="on">
                                        <v-icon left dark>mdi-account-plus</v-icon>Add New Subject
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title class="heading">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" v-if="editedIndex == -1">
                                                    <v-text-field v-model.trim="editedItem.course_code" label="Subject Code" :hint="editedItem.course_code!=''?'':'Please enter Subject Code'" persistent-hint></v-text-field>
                                                </v-col>
                                                  <v-col cols="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model.trim="editedItem.course_code" readonly filled label="Subject Code" :hint="editedIndex != -1 ?'You cannot edit course code':'For example, admin@pu.com'" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field v-model.trim="editedItem.course_name" label="Subject Name" :hint="editedItem.course_name!=''?'':'Please enter Subject Name'" persistent-hint></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="programtype_list" v-model="editedItem.programtype" label="Select Prgramm Type" :rules="[v => !!v || 'required']" :hint="editedItem.programtype!=''?'':'Please Select Subject Name'" persistent-hint></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Program Type
                                                    <v-autocomplete dense v-model="editedItem.programtype" :items="programtype_list" item-value="id"  :hint="editedItem.programtype!=''?'':'Please Select Subject Name'" persistent-hint :error="errorMsg.programtype?true:false" :error-messages="errorMsg.programtype?'Required':''"></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="program_list" v-model="editedItem.program" label="Select Prgramm " :rules="[v => !!v || 'required']" :hint="editedItem.program!=''?'':'Please Select Program'" persistent-hint></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Program
                                                    <v-autocomplete dense v-model="editedItem.program" readonly filled  :items="program_list" item-value="id" :hint="editedIndex != -1 ?'You cannot edit program':'For example, admin@pu.com'" persistent-hint :error="errorMsg.program?true:false" :error-messages="errorMsg.program?'Required':''"></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="lang_list" v-model="editedItem.language" label="Select Lanaguage " :rules="[v => !!v || 'required']" :hint="editedItem.language!=''?'':'Please Select Language'" persistent-hint></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Language
                                                    <v-autocomplete dense v-model="editedItem.language" :items="lang_list" item-value="id" :hint="editedItem.language!=''?'':'Please Select Language'" persistent-hint :error="errorMsg.language?true:false" :error-messages="errorMsg.language?'Required':''"></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="year_list" v-model="editedItem.year" label="Select year " :rules="[v => !!v || 'required']" :hint="editedItem.year!=''?'':'Please Select Year'" persistent-hint></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Year
                                                    <v-autocomplete dense v-model="editedItem.year" readonly filled :items="year_list" item-value="id" :hint="editedIndex != -1 ?'You cannot edit year':'For example, admin@pu.com'" persistent-hint :error="errorMsg.year?true:false" :error-messages="errorMsg.year?'Required':''"></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active?"></v-checkbox>
                                                </v-col>
                                                <v-col>
                                                    <input type="hidden" v-model="editedItem.id" name="id" />
                                                    <!--  <v-hidden v-model="editedItem.id" label="id"></v-hidden> -->
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
                                        <v-btn class="button" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                        <tr class="t-row">
                        <div>
                            <th class="d-flex">
                                <span v-for="header in headers" :key="header.text">
                                   <span v-if="filters.hasOwnProperty(header.value)">
                                    <v-autocomplete class="mr-5" flat hide-details small dense outlined :label="header.text" multiple clearable :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                                   </span>
                                   
                                </span>
                              
                            </th>
                        </div>
                    </tr>
                    </template>
                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                            <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div>
                            <v-avatar size="33" class="edit-avatar">
                                <v-icon color="rgb(1, 127, 152)" size="18" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                </v-data-table>
            </template>
        </v-card>
        <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
            <v-card color="#4CAF50" dark>
                <v-card-text>
                    "Please wait..." while file is Importing?
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        errorMsg: {
            programtype: false,
            program: false,
            language: false,
            year: false,
        },
        org: "",
        dialog_send: false,
        file: null,
        loading3: false,
        tempname: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        load: false,
        dialog: false,
        isLoading :false,
        course_list: null,
        programtype_list: null,
        lang_list: null,
        program_list: null,
        year_list: null,
        export_table_headers:{
                'Sr.No.': 'srno',
                'Subject Code': 'course_code',
                'Subject Name': 'course_name',
                'Program Type': 'programtype',
                'Mobile Number': 'mobilenumber',
                'Program': 'program',
                'Year': 'year',
                'Language' : 'language',
                'Active' : 'isactive'
            },
        headers: [{
                text: "Sr.NO",
                value: "srno"
            },
            {
                text: "Subject Code",
                value: "course_code"
            },
            {
                text: "Subject Name",
                value: "course_name"
            },
            {
                text: "Program Type",
                value: "programtype",
            },
            {
                text: "Program",
                value: "program",
            },
            {
                text: "Language",
                value: "language",
            },
            {
                text: "Year",
                value: "year",
            },
            {
                text: "Active",
                value: "isactive",
            },
            {
                text: "Actions",
                value: "actions",
                sortable: false
            },
        ],
        filters: {
                course_code: [],
                course_name: [],
                programtype: [],
                program: [],
                language: [],
                year: [],
               
                
               
            },
            selected: [],
                filterArr: [],

        editedIndex: -1,
        editedItem: {
            id: "",
            course_code: "",
            course_name: "",
            course_abbr: "",
            programtype: "",
            program: "",
            year: "",
            language: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            course_code: "",
            course_name: "",
            course_abbr: "",
            programtype: "",
            program: "",
            language: "",
            year: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Subject" : "Edit Subject";
        },
        course_list1() {
               return this.course_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    mounted() {
        /* axios
            .post("/AdminImport/importSubjectHome")
            .then(res => {
                if (res.data.msg == "200") {
                    this.course_list = res.data.course_list;
                    this.programtype_list = res.data.programtype_list;
                    this.program_list = res.data.program_list;
                    this.lang_list = res.data.lang_list
                    this.year_list = res.data.year_list
                    this.load = true;
                } else {}
            })
            .catch(error => {
                window.console.log(error);
            });*/
        this.loadData();
    },

    methods: {
           getFiltered(e) {
                console.log(e);
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.course_list.map((d) => d[val]);
            },
        loadData() {
            axios
                .post("/AdminImport/importSubjectHome")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.course_list = res.data.course_list;
                        this.programtype_list = res.data.programtype_list;
                        this.program_list = res.data.program_list;
                        this.lang_list = res.data.lang_list;
                        this.year_list = res.data.year_list;
                        this.org = res.data.org;
                        this.load = true;
                    } else {}
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        submitFile() {
            if (this.file == null) {
                this.showSnackbar("#b71c1c", "Please select the file!");
                //alert("Please select the file!");
            } else {
                this.output_load = true;
                this.dialog_send = true;
                let formData = new FormData();
                formData.append("file", this.file);
                axios
                    .post("AdminImport/importSubject", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.course_list = res.data.course_list;
                            this.load = true;
                            this.output_load = false;
                            this.dialog_send = false;
                            this.loadData();
                            this.showSnackbar("#4CAF50", "Subject Import Successfully !!");
                        } else {
                            this.output_load = false;
                            this.dialog_send = false;
                            this.showSnackbar("#b71c1c", res.data.datamsg);
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
                //     }
            }
        }, //end of the fuction

        initializeErrorMsgFalse() {
            this.errorMsg.programtype = false;
            this.errorMsg.language = false;
            this.errorMsg.program = false;
            this.year = false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {
            this.editedIndex = this.course_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        close() {
            this.dialog = false;
            this.output_load = false;
            this.dialog_send = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    //  console.log("edit.." + this.editedItem);

                    axios
                        .post("/AdminImport/editSubject", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                Object.assign(this.course_list[this.editedIndex], this.editedItem);
                                this.loadData();
                                this.showSnackbar("#4caf50", "Subject Edited Successfully..."); // show snackbar on success
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", " Subject Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/AdminImport/saveSubject", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.course_list.push(this.editedItem);
                                this.loadData();
                                this.showSnackbar("#4caf50", " Subject Added Successfully..."); // show snackbar on success
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", " Subject Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }
        }, // end of save()

        isValidated() {
            if (this.editedItem.programtype && this.editedItem.program && this.editedItem.year && this.editedItem.language) {
                return true;
            } else {
                if (!this.editedItem.programtype) {
                    this.errorMsg.programtype = true;
                }
                if (!this.editedItem.program) {
                    this.errorMsg.program = true;
                }
                if (!this.editedItem.year) {
                    this.errorMsg.year = true;
                }
                if (!this.editedItem.language) {
                    this.errorMsg.language = true;
                }
                return false;
            }
        },

        synchsubject()
        {
        this.isLoading = true;
        axios
            .post("/Erpsynch/synchCourse")
            .then((res) => {
                if (res.data.status == "200") {
                    this.showSnackbar("#4caf50", "Courses Synchronized Successfully..!"); 
                    this.isLoading = false;
                } else if (res.data.status.code == "NA") {
                    this.showSnackbar("#b71c1c", "Error While Synchronization"); 
                    this.isLoading = false;
                }
                else{
                    this.showSnackbar("#b71c1c", "Error While Synchronization"); 
                    this.isLoading = false;
                }
            })
            .catch((error) => {
                window.console.log(error);
                this.isLoading = false;
            });
        },
    },
};
</script>

<style scoped>
.downbtn {
    float: right;
}

.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
.box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    @media only screen and (max-width: 600px) {
        .flex {
            display: block;
        }
    }
</style>
